// importing actions
import {START_ADD_ANNOUNCEMENT, SUCCESS_ADD_ANNOUNCEMENT, FAILED_ADD_ANNOUNCEMENT} from './actions/addAnnouncement'
import {START_FETCH_ANNOUNCEMENT_LIST, SUCCESS_FETCH_ANNOUNCEMENT_LIST, FAILED_FETCH_ANNOUNCEMENT_LIST} from './actions/getAnnouncementList'
import {START_DELETE_ANNOUNCEMENT, SUCCESS_DELETE_ANNOUNCEMENT, FAILED_DELETE_ANNOUNCEMENT} from './actions/getAnnouncementList'
import {START_UPDATE_ANNOUNCEMENT, SUCCESS_UPDATE_ANNOUNCEMENT, FAILED_UPDATE_ANNOUNCEMENT} from './actions/updateAnnouncement'
import {START_SEARCH_ANNOUNCEMENT_LIST, SUCCESS_SEARCH_ANNOUNCEMENT_LIST, FAILED_SEARCH_ANNOUNCEMENT_LIST} from './actions/searchAnnouncement'
import { SET_CURRENT_TAB_STATE } from './actions/setCurrentTabState';

const initState = {
  list: [],
  count: 0,
  fetching: false,
  adding: false,
  currentTabState: {
    tabName: 'all',
    tabIndex: 0
  }
}

export default function announcementList(state = initState, action){
  switch(action.type){

    // Fetching
    case START_FETCH_ANNOUNCEMENT_LIST: {
      return {...state, ...action.payload}
    }
    case SUCCESS_FETCH_ANNOUNCEMENT_LIST: {
      const {result_list, total_amount, fetching, hasPermission, school_has_announcement} = action.payload
      return {...state, list: result_list, count: total_amount, fetching, hasPermission, school_has_announcement}
    }
    case FAILED_FETCH_ANNOUNCEMENT_LIST: {
      const {error, fetching, hasPermission} = action.payload

      return {...state, error, hasPermission, fetching}
    }

    // Adding
    case START_ADD_ANNOUNCEMENT: {
      const { announcementInfo } = action.payload;
      const newList = state.list;

      newList.push(announcementInfo);
      return {...state, newList}
    }
    case SUCCESS_ADD_ANNOUNCEMENT: {
      return {...state, adding: action.payload.adding}
    }
    case FAILED_ADD_ANNOUNCEMENT: {
      return {...state, err: action.payload}
    }

    // Deleting
    case START_DELETE_ANNOUNCEMENT: {
      return {...state, ...action.payload}
    }
    case SUCCESS_DELETE_ANNOUNCEMENT: {
      return {...state, fetching: action.payload.deleting}
    }
    case FAILED_DELETE_ANNOUNCEMENT: {
      return {...state, err: action.payload}
    }

    // Updating
    case START_UPDATE_ANNOUNCEMENT: {
      return {...state, ...action.payload}
    }
    case SUCCESS_UPDATE_ANNOUNCEMENT: {
      return {...state, fetching: action.payload.deleting}
    }
    case FAILED_UPDATE_ANNOUNCEMENT: {
      return {...state, err: action.payload}
    }

    // Searching
    case START_SEARCH_ANNOUNCEMENT_LIST: {
      return {...state, ...action.payload}
    }
    case SUCCESS_SEARCH_ANNOUNCEMENT_LIST: {
      return {...state, list: action.payload.result_list, count: action.payload.total_amount, fetching: action.payload.fetching}
    }
    case FAILED_SEARCH_ANNOUNCEMENT_LIST: {
      return {...state, err: action.payload}
    }
    case SET_CURRENT_TAB_STATE: {
      return {...state, currentTabState: action.payload}
    }
    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/redux/reducer.js